export const changeSizeByTypeObjectWithScale = (type: string): boolean => {

    const typeObject = ['sensor', 'engine', 'star', 'valve', 'triangle', 'oval'];

    return typeObject.indexOf(type) !== -1;
};